
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { Spinner } from "@chakra-ui/react";
import { createContext, useContext, useEffect, useState } from "react";
import API from "../services/api/API";

const TOKEN_REFRESH_INTERVAL = 30 * 60 * 1000; // 30m

export const APIContext = createContext({} as any);

type ProviderProps = {
  children: JSX.Element
}

export function APIProvider({ children }: ProviderProps) {

  const { instance, accounts } = useMsal();
  const [token, setToken] = useState('');
  const [api, setApi] = useState<any>();

  useEffect(() => {

    const refreshToken = () => {
      const request = {
        scopes: ["openid", "offline_access"],
        account: accounts[0],
      };
      instance.acquireTokenSilent(request)
        .then(response => {
          setToken(response.idToken);
        })
        .catch(error => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.loginRedirect({
              scopes: ["openid", "offline_access"],
            });
          }
          console.error(error);
        });
    };

    refreshToken();
    const interval = setInterval(refreshToken, TOKEN_REFRESH_INTERVAL);
    return () => clearInterval(interval);


  }, [instance, accounts]);

  useEffect(() => {
    (async () => {
      if (token) {
        if (!api) {
          setApi(new API(token));
        } else if (api.token !== token) {
          api.setToken(token);
        }
      }
    })();
  }, [token]);


  return (
    <APIContext.Provider
      value={{ api }}
    >
      {api ? children : <Spinner style={{ position: 'fixed', top: '50%', left: '50%' }} size="lg" color="red" />}
    </APIContext.Provider>
  )
}

export function useAPI() {
  const context = useContext(APIContext);
  return context;
}